<template>
  <b-button variant="primary" @click="verifyIdentity">
    Verificar Identidad Mediante Clave &Uacute;nica
  </b-button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VerifyIdentity',
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
  },
  methods: {
    verifyIdentity() {
      const rutEmpresa = this.company.iut;
      const env = process.env.VUE_APP_AMBIENTE;
      const encodedToken = this.fixedEncodeURIComponent(this.currentUser.token);
      const callback = this.fixedEncodeURIComponent(
        `https://${this.getBasePath()}/${this.getAmbit()}/usuario/perfil/verificacion/esign7?status=`
      );
      const url = `https://api.febos.cl/${env}/usuarios/firma/enrrolamiento?`
        + `empresa=${rutEmpresa}&token=${encodedToken}&`
        + `urlCallback=${callback}ok&urlCallbackError=${callback}error`;
      console.log(`https://${this.getBasePath()}/${this.getAmbit()}/usuario/perfil/verificacion/esign7?status=`);
      window.location.href = url;
    },
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str)
        .replace(/[!'()]/g, escape)
        .replace(/\*/g, '%2A');
    },
    getAmbit() {
      const options = /cloud|proveedores|cliente/i;
      const defaultAmbit = 'cloud';
      try {
        const parts = window.location.href
          .replace('https://', '')
          .replace('http://', '')
          .split('/');
        if (parts[0].includes('localhost')) {
          return parts[2].match(options) ? parts[2] : defaultAmbit;
        }
        return parts[3].match(options) ? parts[3] : defaultAmbit;
      } catch (e) {
        return defaultAmbit;
      }
    },
    getBasePath() {
      const resultados = window.location.href
        .replace('https://', '')
        .replace('http://', '')
        .split('/');
      console.log(`RESULTADOS ${ resultados}`);
      return resultados != null && resultados.length >= 0 ? resultados[0] : '';
    }
  }
};
</script>
